import React from 'react';
import snipeLogo from '../../assets/snipe_logo.png';
import { useAuth } from '../../context/AuthContext';

function SideNav({ activeTab, setActiveTab }) {
    const { user, hasRole } = useAuth();
    const discordLinked = user?.discordLinked;
    const canSeeHotProps = hasRole('HOT_PROPS');

    const discordItem = {
        id: 'discord',
        label: 'Discord',
        icon: 'M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z',
        showWhen: true,
    };
    const snipeFeedItem = {
        id: 'snipe-feed',
        label: 'Snipe Feed',
        icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
        showWhen: true,
    };
    const oddsScreenItem = {
        id: 'odds-screen',
        label: 'Odds Screen',
        icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
        showWhen: true,
    };
    const hotPropsItem = {
        id: 'hot-props',
        label: 'Hot Props',
        icon: 'M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003.436 4.314 9.018 9.018 0 01-.436-1.833zM12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.975 5.975 0 01-2.133-1.001A3.75 3.75 0 0012 18z',
        showWhen: canSeeHotProps,
        accent: 'amber',
    };
    const resultsTrackerItem = {
        id: 'results-tracker',
        label: 'Results',
        icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
        showWhen: true,
    };
    const manageSubsItem = {
        id: 'manage-subscriptions',
        label: 'Billing',
        icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z',
        showWhen: true,
    };

    const allMenuItems = discordLinked
        ? [snipeFeedItem, oddsScreenItem, hotPropsItem, resultsTrackerItem, manageSubsItem, discordItem]
        : [discordItem, snipeFeedItem, oddsScreenItem, hotPropsItem, resultsTrackerItem, manageSubsItem];

    const menuItems = allMenuItems.filter(item => item.showWhen);

    const handleNavClick = (itemId) => {
        setActiveTab(itemId);
    };

    return (
        <aside
            className="fixed left-0 top-0 h-full w-[104px] bg-[#060b18] border-r border-slate-800/60 hidden md:flex flex-col"
            style={{ zIndex: 9999 }}
            aria-label="Primary"
        >
            {/* Logo */}
            <div className="h-[72px] flex items-center justify-center border-b border-slate-800/60">
                <img src={snipeLogo} alt="Snipe" className="h-9 w-auto object-contain" />
            </div>

            {/* Nav */}
            <nav className="flex-1 py-4 px-2">
                <ul className="space-y-1">
                    {menuItems.map((item) => {
                        const isActive = activeTab === item.id;
                        const isFilled = item.accent === 'amber';
                        return (
                            <li key={item.id} className="relative">
                                {/* Active left rail */}
                                <span
                                    aria-hidden="true"
                                    className={`absolute -left-2 top-2 bottom-2 w-[2px] rounded-r transition-all duration-200 ${
                                        isActive ? 'bg-emerald-400' : 'bg-transparent'
                                    }`}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleNavClick(item.id)}
                                    title={item.label}
                                    aria-current={isActive ? 'page' : undefined}
                                    className={`group w-full flex flex-col items-center gap-1.5 px-1 py-2.5 rounded-md transition-colors duration-150 ${
                                        isActive
                                            ? 'text-white bg-slate-800/40'
                                            : 'text-slate-500 hover:text-white hover:bg-slate-800/30'
                                    }`}
                                >
                                    <svg
                                        className={`w-5 h-5 transition-colors ${
                                            isActive ? 'text-emerald-400' : 'text-current'
                                        }`}
                                        fill={isFilled ? 'currentColor' : 'none'}
                                        stroke={isFilled ? 'none' : 'currentColor'}
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={isFilled ? '0' : '1.75'}
                                            d={item.icon}
                                        />
                                    </svg>
                                    <span className="text-[10px] font-medium tracking-wide leading-none">
                                        {item.label}
                                    </span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
}

export default SideNav;
